import { GetTechpackShareQuery, GetFolderTechpackQuery } from '@/graphql/generated/types'
import { GetElem } from '@/graphql/helpers'
import { defaultTo, map, omit, pipe } from 'lodash/fp'
import prettyBytes from 'pretty-bytes'
import { UITechpackModel } from '..'

const attachMetadata = pipe(
  map(omit('__typename')),
  map((att: GetElem<GetFolderTechpackQuery['getFolderTechpack']['attachments']>) => {
    return Object.assign({}, att, {
      metadata: {
        fileSize: getfileSize(att?.metadata?.ContentLength as number),
        fileType: getDisplayContentType(att.link as string, att.metadata?.ContentType as string)
      }
    })
  }),
  defaultTo([])
)
const removeTypeNameSafelyForObject = pipe(omit('__typename'), defaultTo({ _id: '', name: '' }))

function getDisplayContentType(signedUrl: string, contentType = ''): string {
  const contentTypeDefault = defaultTo(contentType)
  const url = new URL(signedUrl)
  const pathParts = url.pathname.split('.')
  if (pathParts.length >= 1) {
    return contentTypeDefault(pathParts[pathParts.length - 1]).toUpperCase()
  }
  return contentType.toUpperCase()
}

function getfileSize(bytes: number): string {
  if (!bytes || !Number(bytes) || !Number.isFinite(bytes)) return 'Size Unavailable'
  return prettyBytes(bytes)
}

/**
 * converts a loosely typed graphQL techpack (due to library support)
 * to a strongly typed internal state object
 * @param graphData data returned from graphQL response
 */
export default function techpackDataMapper(
  graphData: GetTechpackShareQuery['getTechpackShare']
): UITechpackModel | null {
  if (!graphData) return null
  if (!graphData?.techpack) return null
  return {
    _id: graphData._id || '',
    link: graphData.link || '',
    attachments: attachMetadata(graphData.techpack.attachments),
    product: removeTypeNameSafelyForObject(graphData.techpack.product),
    metadata: {
      fileSize: getfileSize(Number(graphData.metadata?.ContentLength)),
      fileType: getDisplayContentType(graphData.link || '', graphData.metadata?.ContentType || '')
    }
  }
}

/**
 * converts a loosely typed graphQL techpack (due to library support)
 * to a strongly typed internal state object
 * @param graphData data returned from graphQL response
 */
export function mapTechpackToUITechpackModel(
  graphData: GetFolderTechpackQuery['getFolderTechpack']
): UITechpackModel | null {
  if (!graphData) return null
  return {
    _id: graphData._id || '',
    link: graphData.link || '',
    attachments: attachMetadata(graphData.attachments),
    product: removeTypeNameSafelyForObject(graphData.product),
    metadata: {
      fileSize: getfileSize(Number(graphData.metadata?.ContentLength)),
      fileType: getDisplayContentType(graphData.link || '', graphData.metadata?.ContentType || '')
    }
  }
}
